import { hidePlanUploadFile } from '../../actions/table/plan_uploads';

const initialState = {
  files: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.plan_uploads/UPLOAD_PLAN':
      return {
        ...state,
        files: [...state.files, action.file],
      };
    case 'table.plan_uploads/UPLOAD_PLAN_PROGRESS':
      return {
        ...state,
        files: _.map(state.files, (file) => {
          if (file.id == action.id) {
            file.progress = parseFloat(
              (action.progress.loaded / action.progress.total) * 100
            ).toFixed(1);
          }

          return file;
        }),
      };
    case 'table.plan_uploads/UPLOAD_PLAN_SUCCESS':
      return {
        ...state,
        files: _.map(state.files, (file) => {
          if (file.id == action.request.id) {
            file.success = true;

            setTimeout(() => {
              hidePlanUploadFile(action.request.id);
            }, 10000);
          }

          return file;
        }),
      };
    case 'table.plan_uploads/UPLOAD_PLAN_REQUEST':
      return {
        ...state,
        files: _.map(state.files, (file) => {
          if (file.id == action.id) {
            file.cancel = action.cancel;
          }

          return file;
        }),
      };
    case 'table.plan_uploads/UPLOAD_PLAN_FAILURE':
      return {
        ...state,
        files: _.map(state.files, (file) => {
          if (file.id == action.request.id) {
            file.success = false;

            setTimeout(() => {
              hidePlanUploadFile(action.request.id);
            }, 10000);
          }

          return file;
        }),
      };
    case 'table.plan_uploads/MINIMIZE_PLAN_UPLOADS':
      return {
        ...state,
        minimize: true,
        wizard_active: undefined,
      };
    case 'table.plan_uploads/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.plan_uploads/LIST_PLAN_UPLOADS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    case 'table.plan_uploads/CHANGE_PLAN_STATUS':
      return {
        ...state,
        data: _.map(state.data, (row) => {
          if (row.id == action.plan) {
            row.status = action.processed;
          }

          return row;
        }),
      };
    case 'table.plan_uploads/CHANGE_PLAN_OCR_PROCESSING_STATUS':
      return {
        ...state,
        data: _.map(state.data, (row) => {
          if (row.id == action.plan) {
            row.ocr_processing = action.status;
          }

          return row;
        }),
      };
    case 'table.plan_uploads/HIDE_PLAN_UPLOAD_FILE':
      return {
        ...state,
        files: _.reject(state.files, (file) => file.id == action.plan),
      };

    case 'table.plan_uploads/READ_PLAN_UPLOAD':
      return {
        ...state,
        flyout: action.response.data,
      };
    default:
      return state;
  }
}
